<template>
  <div class="invoice">
    <v-container class="d-flex-column">
      <invoice :invoiceId="this.$route.params.invoid">
        <template v-slot:tabsright>
          <v-tab :to="{ name: 'customer-info' }">Συναλλαγες</v-tab>
          <v-tab :to="{ name: 'customer-invoices' }">Τιμολογια</v-tab>
          <v-tab :to="{ name: 'customer-quotes' }">Προσφορές</v-tab>
        </template>
      </invoice>
      <router-view></router-view>
    </v-container>
  </div>
</template>

<script>
import Invoice from "../components/Invoice.vue";


export default {
  components: {
    Invoice,
  },
  data() {
    return {
      expanded: [],
      timdialog: false,
      diaitems: {},
      loading: true,
      balance: 0.0,
      info: {
        name: "",
        address: "",
        telephone: "",
        nino: "",
        doi: "",
        city: "",
      },
      search: "",
      customer_id: this.$route.params.id,
      invoices: [],
      headers: [
        {
          text: "Αρ. Τιμολογίου",
          align: "start",
          //sortable: false,
          value: "InvoiceId",
          width: "10%",
        },
        { text: "Ημερομηνία", value: "DocDate", width: "10%" },
        { text: "Τυπος", value: "TypeCode" },
        { text: "Οχημα", value: "PlateNumber" },
        { text: "Τρόπος πληρωμής", value: "PaymTerm", sortable: false },
        { text: "Καθαρή αξία", value: "NetValue", align: "end" },
        { text: "ΦΠΑ", value: "VatValue", align: "end" },
        { text: "Συνολο", value: "TotalValue", align: "end" },
        { text: "Actions", value: "actions" },
        { text: "", value: "data-table-expand" },
      ],
    };
  },
  async created() {
  },
  methods: {},
};
</script>
